"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownButton = exports.ContactWrapper = exports.NavWrapper = exports.OverflowWrapper = exports.StyledDropDownNav = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

var _DropdownButton = _interopRequireDefault(require("../../Buttons/DropdownButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledDropDownNav = _styledComponents.default.div.withConfig({
  displayName: "DropDownNavstyles__StyledDropDownNav",
  componentId: "sc-64j5p3-0"
})(["height:", ";overflow:hidden;position:absolute;width:100%;z-index:", ";"], function (props) {
  return props.isOpen ? 'auto' : 0;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('-', props.theme.menu, 1);
});

exports.StyledDropDownNav = StyledDropDownNav;

var OverflowWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropDownNavstyles__OverflowWrapper",
  componentId: "sc-64j5p3-1"
})(["border-radius:", ";display:flex;height:min-content;left:", ";position:relative;width:200%;transition:.3s left;transition-timing-function:ease-in-out;"], function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.isSubNavVisible ? '-100%' : 0;
});

exports.OverflowWrapper = OverflowWrapper;

var NavWrapper = _styledComponents.default.div.withConfig({
  displayName: "DropDownNavstyles__NavWrapper",
  componentId: "sc-64j5p3-2"
})(["border:", ";height:min-content;width:50%;"], function (props) {
  return "\n    ".concat(props.theme.standardButtonBorder, " ").concat(props.theme["c_clickable_".concat(props.colorTheme, "_hover_background")]);
});

exports.NavWrapper = NavWrapper;

var ContactWrapper = _styledComponents.default.a.withConfig({
  displayName: "DropDownNavstyles__ContactWrapper",
  componentId: "sc-64j5p3-3"
})(["text-decoration:none;"]);

exports.ContactWrapper = ContactWrapper;
var StyledDropdownButton = (0, _styledComponents.default)(_DropdownButton.default).withConfig({
  displayName: "DropDownNavstyles__StyledDropdownButton",
  componentId: "sc-64j5p3-4"
})(["height:4.375rem;padding:0 ", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});
exports.StyledDropdownButton = StyledDropdownButton;